var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66872",
    "data-name": "Group 66872",
    transform: "translate(-1268 -367)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2378",
    "data-name": "Ellipse 2378",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1268 367)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bin",
    transform: "translate(1269.803 370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79245",
    "data-name": "Path 79245",
    d: "M22.2,7.339a.775.775,0,0,0-.775-.775H18.1V5.4A1.4,1.4,0,0,0,16.7,4h-5.01a1.4,1.4,0,0,0-1.4,1.4V6.564H6.972a.775.775,0,0,0,0,1.55h14.45a.775.775,0,0,0,.775-.775Zm-5.65-.775h-4.7V5.55h4.7Z",
    transform: "translate(0 0)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79246",
    "data-name": "Path 79246",
    d: "M11.225,20.45a.775.775,0,0,0-.775.775v8.111a3.427,3.427,0,0,0,3.473,3.376H20.34a3.427,3.427,0,0,0,3.473-3.376V21.225a.775.775,0,0,0-.775-.775Zm4.452,8.43a.775.775,0,1,1-1.55,0V24.285a.775.775,0,1,1,1.55,0Zm4.458,0a.775.775,0,1,1-1.55,0V24.285a.775.775,0,1,1,1.55,0Z",
    transform: "translate(-2.934 -11.35)",
    fill: "#929292"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.a9c9686f1a8ac72d8353d7966a016492.svg";
export { ForwardRef as ReactComponent };